<template>
  <div class="layout-column">

    <!-- Minimaler Sicherheitsabstand zum Primärtumor -->

    <div class="flex-gt-sm-100 flex-100 px-2">
      <validation-provider tag="div"
                           :name="path + '.sicherheitsabstand_primaertumor'"
                           :ref="path + '.sicherheitsabstand_primaertumor'"
                           :rules="{integer: true,between:[-1,150]}"
                           v-slot="{ errors }">
        <lx-numberfield :disabled="isDisabled"
                        :dense="denseFields"
                        v-model="model.sicherheitsabstand_primaertumor"
                        :label="$t('FORMS_DIVERSE.MODULE_MALIGNES_MELANOM_SAFETY_DISTANCE')"
                        separator=","
                        suffix="mm"
                        :maxLength="3"
                        @input="refactorEmptyIntValue(model.sicherheitsabstand_primaertumor, null, 'sicherheitsabstand_primaertumor')"
                        :hint="$t('FORMS_DIVERSE.MODULE_MALIGNES_MELANOM_SAFETY_DISTANCE_HINT')"
                        persistent-hint
                        :error-messages="errors[0]"
        ></lx-numberfield>
      </validation-provider>
    </div>

    <!-- Tumordicke -->

    <div class="flex-gt-sm-50 flex-100 px-2">
      <validation-provider tag="div"
                           :name="path + '.tumor_dicke'"
                           :ref="path + '.tumor_dicke'"
                           :rules="{decimal:2, between: [0.01,99.0]}"
                           v-slot="{ errors }">
        <lx-numberfield :disabled="isDisabled"
                        :dense="denseFields"
                        v-model="model.tumor_dicke"
                        :label="$t('FORMS_DIVERSE.MODULE_MALIGNES_MELANOM_TUMOR_THICKNESS')"
                        separator=","
                        suffix="mm"
                        :decimal="2"
                        :hide-details="!errors || errors.length <= 0"
                        @input="refactorEmptyIntValue(model.tumor_dicke, null, 'tumor_dicke')"
                        :hint="$t('FORMS_DIVERSE.MODULE_MALIGNES_MELANOM_TUMOR_THICKNESS_HINT')"
                        persistent-hint
                        :error-messages="errors[0]"
        ></lx-numberfield>
      </validation-provider>
    </div>

    <!-- LDH-Wert -->

    <div class="flex-gt-sm-50 flex-100 px-2">
      <validation-provider tag="div"
                           :name="path + '.ldh'"
                           :ref="path + '.ldh'"
                           :rules="{integer: true,between:[1,10000]}"
                           v-slot="{ errors }">
        <lx-numberfield :disabled="isDisabled"
                        :dense="denseFields"
                        v-model="model.ldh"
                        :label="$t('FORMS_DIVERSE.MODULE_MALIGNES_MELANOM_LDH')"
                        separator=","
                        :hide-details="!errors || errors.length <= 0"
                        suffix="U/l"
                        :maxLength="5"
                        @input="refactorEmptyIntValue(model.ldh, null, 'ldh')"
                        :hint="$t('FORMS_DIVERSE.MODULE_MALIGNES_MELANOM_LDH_HINT')"
                        persistent-hint
                        :error-messages="errors[0]"
        ></lx-numberfield>
      </validation-provider>
    </div>

    <!-- Ulzeration -->

    <div class="flex-100 px-2">
      <validation-provider tag="div"
                           :name="path + '.ulzeration'"
                           :ref="path + '.ulzeration'"
                           rules=""
                           class="flex layout-column"
                           v-slot="{ errors }">
        <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_MALIGNES_MELANOM_ULZERATION')"
                          :disabled="isDisabled"
                          :errors="errors.length > 0">
            <div class="layout-row px-4 pb-3 pt-2 flex">
              <div class="layout-column mr-3 layout-align-center-start">
                <v-radio-group :dense="denseFields" v-model="model.ulzeration" hide-details :error-messages="errors[0]" class="ma-0 pa-0"
                               style="flex:unset;margin-top: 10px;">
                  <v-radio :label="$t('FORMS_DIVERSE.RADIO_GROUP_JNU.YES')"
                           value="J" :disabled="isDisabled"
                           :color="compColor.primeColor" :dark="compColor.isInDarkMode">
                  </v-radio>
                  <v-radio :label="$t('FORMS_DIVERSE.RADIO_GROUP_JNU.NO')"
                           value="N" :disabled="isDisabled"
                           :color="compColor.primeColor" :dark="compColor.isInDarkMode">
                  </v-radio>
                  <v-radio :label="$t('FORMS_DIVERSE.RADIO_GROUP_JNU.UNKNOWN')"
                           value="U" :disabled="isDisabled"
                           :color="compColor.primeColor" :dark="compColor.isInDarkMode">
                  </v-radio>

                  <!-- Reset value of ulzeration via button  -->

                  <v-btn :color="compColor.primeColor"
                         :dark="compColor.isInDarkMode"
                         depressed
                         text
                         width="auto"
                         class="white--text text-none layout-row layout-align-start-center ml-n2 px-2"
                         :class="denseFields ? 'pl-3' : ''"
                         @click="resetRadioButtons('ulzeration')"
                         v-show="model.ulzeration && !isDisabled"
                         :disabled="!model.ulzeration || isDisabled"
                         :title="$t('buttons.deleteSelection.title')">
                    <v-icon :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass"
                            size="24">mdi-arrow-up-bold
                    </v-icon>
                    <span class="ml-2" :class="compColor.primeHighlightClass + '--text'">{{ $t('buttons.deleteSelection.value') }}</span>
                  </v-btn>
                </v-radio-group>
              </div>

              <div class="flex mx-1 px-3 mb-2 report layout-row layout-align-start-center"
                   :class="[!compColor.isInDarkMode ? compColor.prime + ' lighten-5 white--text ' : '']"
                   style="border:1px solid;border-radius: 9px;"
                   :style="{'border-color': compColor.isInDarkMode ? compColor.primeHighlightColor : 'transparent'}">
                <div class="layout-column layout-align-center-center mr-3">
                  <v-icon size="30" :color="compColor.prime">mdi-information</v-icon>
                </div>
                <span style="font-size: 14px;" :class="compColor.primeClass">{{ $t('COMPONENT_DOCUMENTATION.HINT_ULZERATION_MALIGNES_MELANOM') }}</span>
              </div>
            </div>
        </fake-input-frame>

        <span class="error--text" style="line-height:12px;font-size:12px;margin-top: 3px;margin-left:10px;">{{ errors[0] }}</span>
      </validation-provider>
    </div>
  </div>

</template>

<script>
import metaData from '../shared/formsMetaData'
import utils from '../../../common/utils'

export default {
  name: "ModulMalignesMelanom",
  mixins: [metaData, utils],
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    path: {
      type: String
    },
    isDisabled: {
      type: Boolean
    },
    base: {
      type: Object
    },
    tnm: {
      type: Object
    },
    formKey: {
      type: String
    },
    validationRef: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      visible: false,
      model: {}
    }
  },
  methods: {
    /**
     * Reset selected radio-button and trigger dirty flag of validator for save
     */
    resetRadioButtons (field) {
      this.$delete(this.model, field)
      this.validationRef.fields[this.path + '.' + field].changed = true
    },
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue
        }
      },
      immediate: true
    },
    'base.primaertumor_icd_code': {
      // reset module if already existing icd10 code has been changed
      handler: function (newValue, oldValue) {
        if (newValue && oldValue && newValue !== oldValue && !this.isDisabled) {
          this.model = {}
        }
      },
      immediate: true
    }
  }
}
</script>
